// src/components/Writing/WordFromList.tsx
// Nad ramką z polskim słowem stoi obrazek słowa w osobnej ramce — jak w Napisz Easy.
/* eslint-disable max-len */
import React, { FC } from 'react';
import '../../views/writing/slice/slice';
import { WritingInput } from './WritingInput';
import { FitText } from '../FitText/FitText';

type CardProps = {
  id: any,
  content: string,
  term: string,
  translation: string,
  image?: string,
  setNextWordButton: any,
  setFeedbackInfo: any,
  setTryAgainButton: any;
  setInputContent: any;
  inputContent: any;
  tryAgainButton: boolean;
  tryAgain: any;
  answeredCorrectly: boolean;
};

export const WordFromList: FC<CardProps> = ({
  content, term, id, translation, image,
  setInputContent, inputContent,
  tryAgainButton, tryAgain,
  setNextWordButton,
  setFeedbackInfo,
  setTryAgainButton,
  answeredCorrectly,
}) => (
  <>
    {/* Na telefonie trzymanym poziomo obrazek i karta stoją obok siebie, a pole pod nimi (WritingView.less) */}
    <div className="writing-card-row">
      {/* Ramka stoi też bez obrazka — karta, pole i przyciski nie skaczą między słowami */}
      <div className="writing-pict">
        {/* alt pusty — to samo słowo stoi pod spodem jako napis */}
        {image && <img src={image} alt="" />}
      </div>
      {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
      <FitText
        className="word writing-word"
        id={id}
      >
        {translation}
      </FitText>
    </div>
    <div>
      <WritingInput
        content={content}
        term={term}
        setNextWordButton={setNextWordButton}
        setFeedbackInfo={setFeedbackInfo}
        setTryAgainButton={setTryAgainButton}
        setInputContent={setInputContent}
        tryAgainButton={tryAgainButton}
        tryAgain={tryAgain}
        inputContent={inputContent}
        answeredCorrectly={answeredCorrectly}
      />
    </div>
  </>
);

export default WordFromList;
